import localesEs from '@/shared/i18n/AuthB2C/es';
import { REGISTER_PAGE_KEY } from '@/views/Register/constants';

const es = {
  [REGISTER_PAGE_KEY]: {
    ...localesEs,
    SEO_TITLE: 'Regístrate',
    DESCRIPTION_SEO:
      'Sé parte de la nueva generación de profesionales digitales.',

    YOU_HAVE_ACCOUNT: '¿Ya tienes una cuenta?',
    JOIN_CREHANA: 'Únete hoy',
    REGISTER_TO_CREHANA: 'Regístrate con tú número de teléfono',
    REGISTER: 'Regístrate',
    OR_ALSO: 'o también',
    DO_YOU_HAVE_A_ACCOUNT: '¿Ya tienes una cuenta?',
    LIVE_EXPERIENCE_CREHANA: 'Empieza tu camino de aprendizaje',
    LEGALS_TEXT_1: 'Acepto los ',
    LEGALS_TEXT_2: 'Términos, Condiciones y Políticas de Crehana.',
    AUTH_VALIDATION_LEGALS_REQUIRED:
      'Debes aceptar los Términos, Condiciones y Políticas para continuar.',
    LOGIN_GOOGLE_LABEL: 'Continúa con Google',
    LOGIN_FACEBOOK_LABEL: 'Continúa con Facebook',
    SOCIAL_BUTTON_TEXT: 'Regístrate con',
    SOCIAL_BUTTON_TEXT_LOGIN: 'Inicia Sesión con ',
    CAMPAIGN_AUTH_TITLE:
      'Canjea aquí tu paquete de 10 cursos online gracias a HP.',
    CAMPAIGN_AUTH_SUBTITLE: 'Antes de iniciar, regístrate o inicia sesión.',
    PHONE: 'Teléfono',

    // Validation
    INPUT_REQUIRED: 'Campo requerido',
    VALIDATE_MAX_PASSWORD: 'Tu contraseña debe de tener máximo 6 caracteres',
    VALIDATE_MIN_PASSWORD: 'Tu contraseña debe de tener al menos 6 caracteres',
    VALIDATE_FORMAT_EMAIL: 'Por favor, ingresa un email válido.',
    PASSWORD_DOES_NOT_MATCH: 'Las contraseñas no coinciden',

    SIGN_IN: 'Inicia sesión',
    EMAIL: 'Correo',
    PASSWORD: 'Contraseña',

    CHECKBOX_DATA_USAGE:
      'Autorizo que Crehana use los datos proporcionados para contactarme y recibir promociones, ofertas e información de nuevos productos.',
  },
};

export default es;
